import { memo } from 'react';

import { WizardConfig } from '@/components/common/mass-edit-wizard/config';
import type { ShipmentListItem } from '@/services/shipping/types';

import { ShipmentForm } from './components/ShipmentForm';

type ShipmentsProps = {
  shipmentIds: string[];
  rows: ShipmentListItem[];
  config: WizardConfig;
  onSuccess?: () => void;
  onCancel: () => void;
  themeMode?: 'light' | 'dark';
};

export const Shipments = ({
  shipmentIds,
  rows,
  config,
  onSuccess,
  onCancel,
  themeMode,
}: ShipmentsProps) => {
  return (
    <ShipmentForm
      shipmentIds={shipmentIds}
      rows={rows}
      config={config}
      onSuccess={onSuccess}
      onCancel={onCancel}
      themeMode={themeMode}
    />
  );
};

Shipments.Form = memo(ShipmentForm);
